import { FORMAT_C3_YEAR_DATE } from '@cube3/common/model/schema/resources/metadata-field';
import moment from 'moment';

const yearParser = (val) =>
  val && moment(val).utc().startOf('year').toISOString();

export const dehydrateValue = (value, type, schema) => {
  // TODO: update when this is done serverside and/or add multi-select
  let formated;
  switch (true) {
    case type === 'date' &&
      schema &&
      JSON.parse(schema)?.format === FORMAT_C3_YEAR_DATE:
      formated = yearParser(value);
      break;
    case type === 'waterfall_select':
      formated = value?.value;
      break;

    case type === 'text' || type === 'string' || type === 'textarea':
      formated = value.toString().trim();
      break;
    default:
      formated = value;
      break;
  }

  return formated;
};
